module.exports = __webpack_public_path__ + "img/Yongxin.a3cf76ac.jpg";